export { default as remixDefault } from './templates/remixDefault'
export { default as simpleEip7702 } from './templates/simpleEip7702'
export { default as introToEIP7702 } from './templates/introToEIP7702'
export { default as blank } from './templates/blank'
export { default as ozerc20 } from './templates/ozerc20'
export { default as ozerc721 } from './templates/ozerc721'
export { default as ozerc1155 } from './templates/ozerc1155'
export { default as zeroxErc20 } from './templates/zeroxErc20'
export { default as gnosisSafeMultisig } from './templates/gnosisSafeMultisig'
export { default as playground } from './templates/playground'
export { default as empty } from './templates/empty'
export { default as semaphore } from './templates/semaphore'
export { default as hashchecker } from './templates/hashchecker'
export { default as rln } from './templates/rln'
export { default as multNr } from './templates/multiplierNoir'
export { default as stealthDropNr } from './templates/stealthdropNoir'

export { contractDeployerScripts } from './script-templates/contract-deployer'
export { etherscanScripts } from './script-templates/etherscan'
export { sindriScripts } from './script-templates/sindri'
export { contractCreate2Factory } from './script-templates/create2-solidity-factory'
export { runSolidityUnittestingAction } from './script-templates/solidity-test-action'
export { runSlitherAction } from './script-templates/slither-action'
export { runJsTestAction } from './script-templates/run-js-test-action'

